/* eslint-disable */
import React from 'react';

const STATUS_STYLES = {
  // Shift statuses
  planned:               { bg: 'rgba(96,165,250,0.12)',  color: '#60a5fa' },
  active:                { bg: 'rgba(74,222,128,0.12)',   color: '#4ade80' },
  closed:                { bg: 'var(--surface-raised)',    color: 'var(--text-muted)' },
  closed_with_open_items:{ bg: 'rgba(251,191,36,0.12)',   color: '#fbbf24' },
  // Allocation statuses
  out:                   { bg: 'rgba(251,191,36,0.12)',   color: '#fbbf24' },
  returned:              { bg: 'var(--surface-raised)',    color: 'var(--text-muted)' },
  carried_over:          { bg: 'rgba(96,165,250,0.12)',   color: '#60a5fa' },
  flagged_missing:       { bg: 'rgba(248,113,113,0.12)',  color: '#f87171' },
};

const LABELS = {
  planned: 'Planned',
  active: 'Active',
  closed: 'Closed',
  closed_with_open_items: 'Open items',
  out: 'Out',
  returned: 'Returned',
  carried_over: 'Carried over',
  flagged_missing: 'Flagged',
};

export default function StatusPill({ status, label }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.closed;
  const text = label || LABELS[status] || status;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '3px 8px', borderRadius: 999,
      fontSize: 10, fontWeight: 600, textTransform: 'uppercase',
      letterSpacing: '0.04em', whiteSpace: 'nowrap',
      background: s.bg, color: s.color,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />
      {text}
    </span>
  );
}
